<div>
  <app-body>
    Please note that this website uses cookies to provide the best experience possible. By continuing to access this site, you are consenting to this use.
  </app-body>
</div>